import React, { useCallback, useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import { FilterBar } from "@/components/FilterBar";
import BackupExcelButton from "@/components/BackupExcelButton";

const F_EMPTY = { q: "", penulis: "", kategori: "", jenis_buku: "" };

export default function BukuKepsek() {
  const [all, setAll] = useState([]);
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/buku", { params: { format: "fisik" } }); setAll(data); }
    catch (e) { console.error(e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const items = all.filter((b) => {
    if (applied.q && !b.judul.toLowerCase().includes(applied.q.toLowerCase())) return false;
    if (applied.penulis && !(b.penulis || "").toLowerCase().includes(applied.penulis.toLowerCase())) return false;
    if (applied.kategori && b.kategori !== applied.kategori) return false;
    if (applied.jenis_buku && !(b.jenis_buku || "").toLowerCase().includes(applied.jenis_buku.toLowerCase())) return false;
    return true;
  });

  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Daftar Buku Fisik (Read-only)" action={<BackupExcelButton endpoint="buku-fisik" filters={{ q: applied.q, penulis: applied.penulis, kategori: applied.kategori, jenis_buku: applied.jenis_buku }} testId="backup-buku-fisik-btn" />} />
      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="kepsek-buku-filter"
        fields={[
          { key: "q", type: "text", label: "Judul", placeholder: "Cari judul" },
          { key: "penulis", type: "text", label: "Penulis", placeholder: "Cari penulis" },
          { key: "kategori", type: "select", label: "Kategori", options: [{ v: "buku_teks_pelajaran", label: "Buku Teks Pelajaran" }, { v: "buku_umum", label: "Buku Umum" }] },
          { key: "jenis_buku", type: "text", label: "Jenis Buku", placeholder: "Cari jenis" },
        ]}
      />
      <section className="pp-card pp-freeze overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Cover</th>
            <th className="text-left px-5 py-3">Judul</th>
            <th className="text-left px-5 py-3">Penulis</th>
            <th className="text-left px-5 py-3">Kategori</th>
            <th className="text-left px-5 py-3">Jenis</th>
            <th className="text-center px-5 py-3">Ready/Total</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-400 italic">Belum ada buku fisik.</td></tr>}
            {items.map((b) => (
              <tr key={b.id} className="pp-row">
                <td className="px-5 py-3">{b.cover_file_id ? <img src={fileUrl(b.cover_file_id)} alt="" className="w-10 h-14 object-cover rounded" /> : <div className="w-10 h-14 bg-slate-100 rounded" />}</td>
                <td className="px-5 py-3 font-medium">{b.judul}</td>
                <td className="px-5 py-3 text-slate-600">{b.penulis}</td>
                <td className="px-5 py-3 text-xs capitalize">{b.kategori.replace("_", " ")}</td>
                <td className="px-5 py-3 text-xs">{b.jenis_buku}</td>
                <td className="px-5 py-3 text-center">{b.ready}/{b.jumlah}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </Layout>
  );
}
